import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import {P2, ValueTitle} from '../Kit/Kit';
import Close from "react-icons/lib/md/close"


const ContentContainer = styled.div`
  display: flex;
  position: relative;
`;

const TeamContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto minmax(auto, 300px);
  margin: auto;
  width: 75%;
  position: relative;
  
  @media (min-width: 768px) {
   grid-template-columns: 2fr 3fr;
   grid-template-rows: 479px;
   width: 100%;
   max-width: 1200px;
  }
  
  svg {
    position: absolute;
    top: 1%;
    right: 1%;
    cursor: pointer;
    font-size: 30px;
    color: #909090
  }
`;

const TeamImg = styled.img`
  width: 100%;
  
  @media(min-width: 768px) {
      width: auto;
      height: 100%;
      justify-self: end;
  }
`;

const BioContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 40px;
  overflow: auto;
  
  .bio p{
    margin-bottom: 20px;
    
    @media(min-width: 768px) {
      margin-bottom: 20px;
    }
  }
`;

const Name = ValueTitle.extend`
  text-align: left;
`;

const Title = P2.extend`
  text-align: left;
  margin: 8px 0 12px;
`;

const BioText = P2.extend`
  text-align: left;
`;

class TeamModal extends React.Component {
    handleClick = (event) => {
        console.log(event.target.tagName);
        if (event.target.tagName === "A") {
            this.props.close()
        }
    };

    render() {
        const {isOpen, close, modalData: {name, position, content, image}} = this.props;
        return (
          <Modal
            isOpen={isOpen}
            onRequestClose={() => close()}
            style={{
                overlay: {
                    position: `fixed`,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: `rgba(0, 0, 0, 0.75)`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                content: {
                    position: `relative`,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: `none`,
                    background: `none`,
                    padding: 0,
                    overflow: `hidden`,
                    WebkitOverflowScrolling: `touch`,
                },
            }}
            contentLabel="Modal"
          >
              <ContentContainer>
                  <TeamContainer>
                      <TeamImg
                        src={image.source_url}
                        alt={image.alt_text}
                      />
                      <BioContainer>
                          <Name
                            dangerouslySetInnerHTML={{__html: name}}
                          />
                          <Title
                            dangerouslySetInnerHTML={{__html: position}}
                          />
                          <BioText
                            className="bio"
                            dangerouslySetInnerHTML={{__html: content}}
                            onClick={(event) => this.handleClick(event)}
                          />
                      </BioContainer>
                      <Close
                        onClick={() => close()}
                      />
                  </TeamContainer>
              </ContentContainer>
          </Modal>
        );
    }
}

export default TeamModal;


// WEBPACK FOOTER //
// ./src/components/Modals/TeamModal.js